export const YES_NO_DONOT = [
  { text: "Don't Know", value: "NA" },
  { text: 'No', value: false },
  { text: 'Yes', value: true }
  
]
